import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';

type ConclusionDropdownState = {
  loading: boolean;
  conclusionDropdowns: ConclusionDropdown[];
};

const initialState: ConclusionDropdownState = {
  loading: false,
  conclusionDropdowns: []
};

export const conclusionDropdownSlice = createAppSlice({
  name: 'conclusion-dropdown',
  initialState,
  reducers: (create) => ({
    getConclusionDropdown: create.asyncThunk(
      async (model: string) => {
        const response = await apiFetcher.get(
          `menu/conclusion-dropdown?MODEL=${model}`
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
          state.conclusionDropdowns = [];
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.conclusionDropdowns = transformerArray(action.payload);
        },
        rejected: (state) => {
          state.loading = false;
        }
      }
    )
  }),

  selectors: {
    watchConclusionDropdownLoading: (conclusionDropdown) =>
      conclusionDropdown.loading,
    watchConclusionDropdownList: (conclusionDropdown) =>
      conclusionDropdown.conclusionDropdowns
  }
});

export const { watchConclusionDropdownLoading, watchConclusionDropdownList } =
  conclusionDropdownSlice.selectors;

export const { getConclusionDropdown } = conclusionDropdownSlice.actions;
